import { NgModule } from '@angular/core'

import { AdvancedTableModule } from './advanced-table'
import { HelpIconModule } from './help-icon'
import { SharedComponentsTestingModule } from './shared-components.testing.module'

@NgModule({
  imports: [
    SharedComponentsTestingModule,
    AdvancedTableModule,
    HelpIconModule,
  ],
  exports: [
    SharedComponentsTestingModule,
    AdvancedTableModule,
    HelpIconModule,
  ],
})
export class ClinicianComponentsTestingModule {}
